/** Stable short fingerprint when schema JSON changes (reorder, save in designer). */
export const fingerprintSchemaJson = (json: unknown): string => {
  if (json === null || json === undefined) {
    return "";
  }
  if (typeof json === "string") {
    return `s:${json.length}:${djb2(json)}`;
  }
  try {
    const s = JSON.stringify(json);
    return `j:${s.length}:${djb2(s)}`;
  } catch {
    return "x";
  }
};

const djb2 = (str: string): string => {
  let hash = 5381;
  for (let i = 0; i < str.length; i += 1) {
    hash = (hash * 33) ^ str.charCodeAt(i);
  }
  return (hash >>> 0).toString(36);
};
